/**
 * Validates if adding products to a unit would mix DG and non-DG items
 * @param {Array} existingProducts - Products already in the unit
 * @param {Array} newProducts - Products being added (format: {product, qty, eq, wt})
 * @returns {Object} {hasConflict: boolean, details: {existingDG, existingNonDG, newDG, newNonDG}}
 */
export function validateDGMix(existingProducts, newProducts) {
  // Count DG types in new products
  const newDG = newProducts.filter(p => p.product.dg === 'Yes').length;
  const newNonDG = newProducts.filter(p => p.product.dg === 'No').length;

  // Count DG types in existing products
  const existingDG = existingProducts.filter(p => p.dg === 'Yes').length;
  const existingNonDG = existingProducts.filter(p => p.dg === 'No').length;

  // Check 1: Are the NEW products themselves a mix of DG and non-DG?
  if (newDG > 0 && newNonDG > 0) {
    return {
      hasConflict: true,
      details: { existingDG, existingNonDG, newDG, newNonDG }
    };
  }

  // Check 2: Do new products conflict with existing products?
  let hasConflict = false;

  if (existingDG > 0 && newNonDG > 0) {
    hasConflict = true;
  }

  if (existingNonDG > 0 && newDG > 0) {
    hasConflict = true;
  }

  return {
    hasConflict,
    details: { existingDG, existingNonDG, newDG, newNonDG }
  };
}
